import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=5f635b58&scoped=true&"
import script from "./TextList.vue?vue&type=script&lang=js&"
export * from "./TextList.vue?vue&type=script&lang=js&"
import style0 from "./TextList.vue?vue&type=style&index=0&id=5f635b58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f635b58",
  null
  
)

export default component.exports